import { defineStore } from "pinia";
import schedulesApi, { DropZoneItemResponse } from "../../Api/schedules";
import { mapDropZoneItemResponse } from "./dropZoneItems";
import type { DropZoneItem } from "./dropZoneItems";

export const useScheduleMainStore = defineStore("scheduleMain", {
    state: () => ({
        eventId: 0,
        eventTimezone: "",
        scheduleId: 0,
        dropZoneItems: [] as DropZoneItem[],
        fetchingCategoriesInProgress: false,
        pendingRequests: 0,
    }),

    getters: {
        hasPendingRequests: state => state.pendingRequests > 0,
    },

    actions: {
        /**
         * Marks the schedule as busy until the given request settles. Switching schedule is blocked meanwhile.
         */
        trackRequest<T>(request: Promise<T>): Promise<T> {
            this.pendingRequests++;

            return request.finally(() => {
                this.pendingRequests--;
            });
        },
        refreshDropZoneItems() {
            this.fetchingCategoriesInProgress = true;

            return this.trackRequest(schedulesApi.getDropZoneItems(this.eventId, this.scheduleId))
                .then((items: DropZoneItemResponse[]) => {
                    this.dropZoneItems = items.map(mapDropZoneItemResponse);
                })
                .finally(() => {
                    this.fetchingCategoriesInProgress = false;
                });
        },
    },
});
